"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var material_1 = require("@mui/material");
var useDropDownSelectStyles = function (_a) {
    var _b, _c;
    var isIconPresent = _a.isIconPresent, isDisabled = _a.isDisabled, isError = _a.isError, shrinkLabel = _a.shrinkLabel;
    var theme = (0, react_1.useTheme)();
    return {
        listItems: (0, react_1.css)({
            '& .MuiListItem-button': {
                '&:focus': {
                    backgroundColor: 'unset',
                },
                '@media (hover: hover)': {
                    '&:hover': {
                        backgroundColor: (0, material_1.lighten)(theme.mvf.palette.component.answerSelectedColor, theme.mvf.filters.lighten.extreme),
                    },
                },
                '&.Mui-selected': {
                    backgroundColor: (0, material_1.lighten)(theme.mvf.palette.component.answerSelectedColor, theme.mvf.filters.lighten.extreme),
                },
            },
            '& .dropdown-paper': {
                backgroundColor: theme.mvf.palette.background.answerBackgroundColor,
                border: 'solid',
                borderWidth: theme.mvf.border.width.thin,
                borderColor: theme.mvf.palette.component.answerUnselectedColor,
                boxShadow: "".concat(theme.mvf.boxShadow.timid, " !important"),
                borderRadius: 4,
                marginTop: '1px',
                '& .MuiListItem-root.Mui-selected, .MuiListItem-button:hover': {
                    backgroundColor: (0, material_1.lighten)(theme.mvf.palette.component.answerSelectedColor, theme.mvf.filters.lighten.extreme),
                },
            },
        }),
        formControl: (0, react_1.css)(__assign({ '& .MuiInputBase-input': (_b = {
                    height: 23,
                    paddingTop: shrinkLabel ? 28 : 18.5,
                    paddingBottom: shrinkLabel ? 11 : 18.5,
                    paddingLeft: isIconPresent ? 0 : theme.mvf.spacing.medium,
                    fontWeight: theme.mvf.typography.weight.thick,
                    fontSize: theme.mvf.fontSize.mini
                },
                _b[theme.breakpoints.up('mobileMedium')] = {
                    fontSize: theme.mvf.fontSize.small,
                },
                _b.backgroundColor = 'unset',
                _b['&:focus'] = {
                    backgroundColor: 'unset',
                },
                _b), '& .MuiInputBase-inputAdornedStart': {
                paddingLeft: 0,
            }, '& .MuiSelect-icon': __assign(__assign({}, (isError && {
                color: theme.mvf.palette.status.error,
            })), (isDisabled && {
                color: 'rgb(225, 225, 225)',
            })), '& .MuiInputBase-root': {
                backgroundColor: theme.mvf.palette.background.answerBackgroundColor,
                border: 'solid',
                borderWidth: theme.mvf.border.width.thin,
                borderColor: theme.mvf.palette.component.answerUnselectedColor,
                boxShadow: theme.mvf.boxShadow.timid,
                borderRadius: 4,
                boxSizing: 'border-box',
                '@media (hover: hover)': {
                    '&:hover': {
                        borderColor: theme.mvf.palette.component.answerSelectedColor,
                    },
                },
                '&.Mui-focused': {
                    borderColor: theme.mvf.palette.component.answerSelectedColor,
                    boxShadow: theme.mvf.boxShadow.heavy,
                },
                '&.Mui-error': {
                    borderColor: theme.mvf.palette.status.error,
                },
            }, '& .MuiInputAdornment-positionStart': __assign({ marginTop: shrinkLabel ? '16px' : '0px !important', marginLeft: theme.mvf.spacing.medium }, (isError && {
                '& .MuiSvgIcon-root': {
                    color: theme.mvf.palette.status.error,
                },
            })), '& .MuiFormLabel-root': {
                lineHeight: 1.6,
                marginLeft: theme.mvf.spacing.medium,
                '&.MuiInputLabel-shrink': __assign({ marginTop: '9px', fontWeight: theme.mvf.typography.weight.thick }, (isIconPresent && {
                    marginLeft: theme.mvf.spacing.medium,
                })),
            } }, (isIconPresent && {
            '& .MuiFormLabel-root:not(.MuiInputLabel-shrink)': {
                marginLeft: 53,
            },
        }))),
        label: (0, react_1.css)((_c = {
                color: theme.mvf.palette.text.primaryTextColor,
                pointerEvents: 'none',
                marginTop: '-2px',
                marginRight: theme.mvf.spacing.medium,
                fontSize: theme.mvf.fontSize.little
            },
            _c[theme.breakpoints.up('mobileMedium')] = {
                fontSize: theme.mvf.fontSize.small,
            },
            _c)),
    };
};
exports.default = useDropDownSelectStyles;
//# sourceMappingURL=makeDropDownSelectStyling.js.map